import { Capacitor } from "@capacitor/core";

import QuickSearchButton from "components/search/QuickSearchButton/QuickSearchButton";
import HideIfKeyboardVisible from "components/shared/HideIfKeyboardVisible";
import useMount from "hooks/useMount";
import faChartUp from "icons/regular/chart-line-up.svg";
import faHouse from "icons/solid/house.svg";
import faSearch from "icons/solid/magnifying-glass.svg";
import faTelescope from "icons/solid/telescope.svg";

import CurrentUserLibraryLink from "./components/CurrentUserLibraryLink";
import MobileBottomNavContent from "./components/MobileBottomNavContent";
import MobileBottomNavLink from "./components/MobileBottomNavLink";
import MobileBottomNavWrapper from "./components/MobileBottomNavWrapper";

export const ActiveLinkStyle = "text-gray-900 dark:text-white font-semibold";
export const InactiveLinkStyle =
  "text-gray-700 hover:text-gray-900 dark:text-gray-400 dark:hover:text-white font-semibold";
export const DisabledLinkStyle =
  "text-gray-700 dark:text-gray-400 font-semibold opacity-50 cursor-not-allowed";

export default function MobileFooter(): JSX.Element {
  const isMounted = useMount();
  const hasSafeArea = Capacitor?.isPluginAvailable("SafeArea");
  const isNative = Capacitor?.isNativePlatform();
  const isAndroid = Capacitor?.getPlatform() === "android";

  return (
    <HideIfKeyboardVisible>
      <>
        <div className="xl:hidden" style={{ height: "120px" }} />
        <nav className="fixed xl:hidden bottom-0 bg-background/80 backdrop-blur-xs border-t border-secondary w-full z-40 shadow-lg">
          <MobileBottomNavWrapper>
            <>
              <MobileBottomNavLink href="/" icon={faHouse} text="Home" />
              <CurrentUserLibraryLink />
              <MobileBottomNavLink
                href="/explore"
                icon={faTelescope}
                text="Explore"
              />
              <MobileBottomNavLink
                href="/trending/month"
                icon={faChartUp}
                text="Trending"
              />

              <QuickSearchButton
                className={isMounted ? InactiveLinkStyle : DisabledLinkStyle}
              >
                <MobileBottomNavContent icon={faSearch} text="Search" />
              </QuickSearchButton>
            </>
          </MobileBottomNavWrapper>
        </nav>

        {isAndroid && isNative && (
          <div
            className="bottom-0 left-0 right-0 fixed bg-gray-900 dark:transparent z-40"
            style={{
              height: hasSafeArea ? "var(--safe-area-inset-bottom, 20px)" : "0",
              display: hasSafeArea ? "block" : "none",
            }}
          />
        )}
      </>
    </HideIfKeyboardVisible>
  );
}
